import React from 'react';
import PropTypes from 'prop-types';
import {
    InputAdornment,
    Input,
    InputLabel,
} from '@material-ui/core';
import RequiredAsterisk from '%app/js/common/components/material/TextField/component/RequiredAsterisk';

function SimpleTextField({
    endAdornments,
    type,
    input: { value, onChange },
    disabled,
    label,
    meta: { error },
    placeholder,
    required,
    inputComponent,
    inputProps,
}) {
    return (
        <React.Fragment>
            <InputLabel>
                { label }
                <RequiredAsterisk required={required} />
            </InputLabel>
            <Input
                value={value}
                onChange={onChange}
                disabled={disabled}
                fullWidth
                type={type}
                error={Boolean(error)}
                placeholder={placeholder}
                endAdornment={endAdornments
                    ? (
                        <InputAdornment position="end">
                            { endAdornments }
                        </InputAdornment>
                    ) : ''}
                inputComponent={inputComponent}
                inputProps={inputProps}
            />
        </React.Fragment>
    );
}

SimpleTextField.propTypes = {
    endAdornments: PropTypes.node,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
    required: PropTypes.bool,
    input: PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
        onChange: PropTypes.func.isRequired,
    }).isRequired,
    meta: PropTypes.shape({
        error: PropTypes.any,
    }).isRequired,
    placeholder: PropTypes.string,
    inputComponent: PropTypes.object,
    inputProps: PropTypes.object,
};

SimpleTextField.defaultProps = {
    required: false,
    type: 'text',
    disabled: false,
    endAdornments: null,
    placeholder: '',
    inputComponent: Input,
    inputProps: {},
};

export default SimpleTextField;
